module.exports = __webpack_public_path__ + "img/mass-coupon-active@3x.png";